import type { Doc as YDoc } from 'yjs';

const COLLAB_INITIAL_CONTENT_META_KEY = 'examdojo.collab.initial-content';
const COLLAB_INITIAL_CONTENT_SEEDED_KEY = 'seeded';

export const isCollabInitialContentSeeded = (ydoc: YDoc): boolean =>
  ydoc.getMap<boolean>(COLLAB_INITIAL_CONTENT_META_KEY).get(COLLAB_INITIAL_CONTENT_SEEDED_KEY) === true;

export const markCollabInitialContentSeeded = (ydoc: YDoc): void => {
  ydoc.getMap<boolean>(COLLAB_INITIAL_CONTENT_META_KEY).set(COLLAB_INITIAL_CONTENT_SEEDED_KEY, true);
};
